"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lottie_light = _interopRequireDefault(require("lottie-web/build/player/lottie_light.min"));

var _lottie_api = _interopRequireDefault(require("lottie-api/dist/lottie_api"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // LottieTypes


var _default = (0, _react.forwardRef)(function Lottie(props, ref) {
  var eventListeners = props.eventListeners;
  ref = ref || _react["default"].createRef({});
  var el = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anim = _useState2[0],
      setAnim = _useState2[1]; // const [animData, setAnimData] = useState(null);


  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      animApi = _useState4[0],
      setAnimApi = _useState4[1];

  var _useState5 = (0, _react.useState)({
    play: true,
    speed: props.speed || 1
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      state = _useState6[0],
      setState = _useState6[1]; // Config


  var _props$options = props.options,
      loop = _props$options.loop,
      autoplay = _props$options.autoplay,
      rendererSettings = _props$options.rendererSettings,
      segments = _props$options.segments;
  var animationData = props.options.animationData;
  if (animationData && animationData["default"]) animationData = animationData["default"];

  var _useState7 = (0, _react.useState)(animationData),
      _useState8 = _slicedToArray(_useState7, 2),
      animationDataPrev = _useState8[0],
      setAnimationDataPrev = _useState8[1];

  var options = _objectSpread({}, props.options, {
    container: el.current || null,
    renderer: 'svg',
    loop: loop !== false,
    autoplay: autoplay !== false,
    segments: segments !== false,
    animationData: animationData,
    rendererSettings: rendererSettings
  });

  var setSpeed = function setSpeed() {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null; // _anim = _anim || anim;
    // if(!_anim) return;
    // _anim.setSpeed(speed || props.speed);

    var s = speed || props.speed;
    setState(function (p) {
      return _objectSpread({}, p, {
        speed: s
      });
    });
  };

  var setDirection = function setDirection() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null; // _anim = _anim || anim;
    // if(!_anim) return;
    // _anim.setDirection(props.direction);

    setState(function (p) {
      return _objectSpread({}, p, {
        direction: direction || props.direction
      });
    });
  };

  var setAnimationControl = function setAnimationControl(_animApi) {
    _animApi = _animApi || animApi;
    if (!_animApi) return;
    var animationControl = props.animationControl;

    if (animationControl) {
      var properties = Object.keys(animationControl);
      properties.forEach(function (property) {
        var propertyPath = _animApi.getKeyPath(property);

        var value = animationControl[property];

        _animApi.addValueCallback(propertyPath, function () {
          return value;
        });
      });
    }
  };

  var play = function play() {
    // _anim = _anim || anim;
    // if(!_anim) return;
    // _anim.play();
    setState(function (p) {
      return _objectSpread({}, p, {
        play: true,
        pause: false,
        segments: null
      });
    });
  };

  var playSegments = function playSegments(segments, shouldForce) {
    // if(!anim) return;
    setState(function (p) {
      return _objectSpread({}, p, {
        segments: segments || props.segments,
        shouldForce: shouldForce
      });
    });
  };

  var stop = function stop() {
    // if(!anim) return;
    // anim.stop();
    setState(function (p) {
      return _objectSpread({}, p, {
        play: false,
        pause: false
      });
    });
  };

  var pause = function pause() {
    // if(!anim) return;
    // if(state.pause != props.isPaused)
    setState(function (p) {
      return _objectSpread({}, p, {
        pause: true
      });
    });
    /*
    if (props.isPaused && !anim.isPaused) {
      // anim.pause();
      setState(p=>({...p, pause: true}));
    } else if (!props.isPaused && anim.isPaused) {
      anim.pause();
    } */
  };

  var destroy = function destroy(_anim) {
    _anim = _anim || anim;

    _anim.destroy();
  };

  var registerEvents = function registerEvents(eventListeners, _anim) {
    if (!eventListeners) return;
    _anim = _anim || anim;
    eventListeners.forEach(function (eventListener) {
      _anim.addEventListener(eventListener.eventName, eventListener.callback);
    });
  };

  var deRegisterEvents = function deRegisterEvents(eventListeners, _anim) {
    if (!eventListeners) return;
    _anim = _anim || anim;
    eventListeners.forEach(function (eventListener) {
      _anim.removeEventListener(eventListener.eventName, eventListener.callback);
    });
  }; // componentDidUpdate


  (0, _react.useEffect)(function () {
    if (props.animationData !== animationDataPrev) {
      setAnimationDataPrev(animationData);
    }

    if (props.isStopped) stop();else if (props.segments && props.segments !== state.segments) {
      var shouldForce = !!props.forceSegments;
      playSegments(props.segments, shouldForce);
    } else {
      play(); // console.log('aw')
    }
    if (props.isPaused) pause();
    if (props.speed) setSpeed(props.speed);
    if (props.direction) setDirection(props.direction); // setAnimationControl();
  }, [props, animationDataPrev]);
  (0, _react.useEffect)(function () {
    options.container = el.current;

    var _anim = _lottie_light["default"].loadAnimation(options);

    var _animApi = _lottie_api["default"].createAnimationApi(_anim);

    setAnim(_anim);
    setAnimApi(_animApi);
    setSpeed(props.speed); // setDirection();

    registerEvents(eventListeners, _anim);
    setAnimationControl(_animApi);
    return function () {
      deRegisterEvents(props.eventListeners, _anim);
      destroy(_anim); // options.animationData = null;
      // setAnim(null);
      // setAnimApi(null);
    };
  }, [el, animationDataPrev]);
  (0, _react.useEffect)(function () {
    if (!anim) return;
    if (state.pause) anim.pause();else if (state.segments) anim.playSegments(state.segments, state.shouldForce);else if (state.play === true) anim.play();else if (state.play === false) anim.stop();
    if (state.speed) anim.setSpeed(state.speed);
    if (state.direction) anim.setDirection(state.direction); // setSpeed(state.speed);
    // (state.direction);
  }, [state, anim]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      play: play,
      registerEvents: registerEvents,
      deRegisterEvents: deRegisterEvents,
      setSpeed: setSpeed,
      setDirection: setDirection,
      anim: anim,
      animApi: animApi,
      playSegments: playSegments,
      pause: pause,
      destroy: destroy,
      stop: stop
    };
  }); // Render

  var width = props.width,
      height = props.height,
      ariaRole = props.ariaRole,
      ariaLabel = props.ariaLabel,
      title = props.title;

  var getSize = function getSize(initial) {
    var size;

    if (typeof initial === 'number') {
      size = "".concat(initial, "px");
    } else {
      size = initial || '100%';
    }

    return size;
  };

  var lottieStyles = _objectSpread({
    width: getSize(width),
    height: getSize(height),
    overflow: 'hidden',
    margin: '0 auto',
    outline: 'none'
  }, props.style);

  return (// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react["default"].createElement("div", {
      ref: el,
      style: lottieStyles,
      title: title,
      role: ariaRole,
      "aria-label": ariaLabel,
      tabIndex: "0"
    })
  );
});
/*
ref={(c) => {
        el = c;
      }}
*/

/*
type LottieTypes = {
  eventListeners: PropTypes.arrayOf(PropTypes.object),
  options: PropTypes.object.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isStopped: PropTypes.bool,
  isPaused: PropTypes.bool,
  speed: PropTypes.number,
  segments: PropTypes.arrayOf(PropTypes.number),
  forceSegments: PropTypes.bool,
  direction: PropTypes.number,
  ariaRole: PropTypes.string,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.string,
};

Lottie.defaultProps = {
  eventListeners: [],
  isStopped: false,
  isPaused: false,
  speed: 1,
  ariaRole: 'button',
  ariaLabel: 'animation',
  title: '',
};
*/


exports["default"] = _default;